import { io } from "socket.io-client";
import { getBackendUrl } from "../config";
import { instrumentSocket } from "./frontendDiagnostics";

const socket = instrumentSocket(io(getBackendUrl(), {
  autoConnect: false,
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
}));

export function connectSocket(token) {
  const cleanToken =
    token?.startsWith('"') && token?.endsWith('"')
      ? token.slice(1, -1)
      : token;

  socket.auth = { token: cleanToken };

  if (!socket.connected) {
    socket.connect();
  }
}

export function disconnectSocket() {
  if (socket.connected) {
    socket.disconnect();
  }
}

export default socket;
